/**
 * Blocs schema.org partagés (Organization / PostalAddress).
 * Centralisés pour garantir que chaque page expose les champs requis
 * (streetAddress, logo en ImageObject, url, contact) — sinon les
 * validateurs (Google Rich Results, Semrush) remontent des erreurs.
 */

export const SITE_URL = "https://dj-val.fr";

/** Transforme une URL d'image locale ("/__l5e/...") en URL absolue (og:image, JSON-LD). */
export function absoluteImageUrl(url: string): string {
  if (!url) return `${SITE_URL}/og-dj-val.jpg`;
  return url.startsWith("http") ? url : `${SITE_URL}${url}`;
}

export const POSTAL_ADDRESS = {
  "@type": "PostalAddress",
  streetAddress: "106 Grand Rue",
  addressLocality: "Cavaillon",
  postalCode: "84300",
  addressRegion: "Vaucluse",
  addressCountry: "FR",
} as const;

export const ORGANIZATION_LOGO = {
  "@type": "ImageObject",
  url: `${SITE_URL}/logo.png`,
  width: 512,
  height: 512,
} as const;

/** Organization complète, utilisable comme publisher/seller/provider. */
export const ORGANIZATION_SCHEMA = {
  "@type": "Organization",
  "@id": `${SITE_URL}/#organization`,
  name: "DJ Val",
  url: SITE_URL,
  logo: ORGANIZATION_LOGO,
  image: `${SITE_URL}/og-dj-val.jpg`,
  telephone: "+33767908667",
  email: "info.djval@gmail.com",
  address: POSTAL_ADDRESS,
} as const;

/**
 * LocalBusiness complète — à utiliser (spread) pour TOUT nœud LocalBusiness,
 * y compris en `provider`/`worksFor`. Un nœud partiel est signalé « non valide »
 * par les validateurs (champs requis : name, address, image, url, telephone).
 */
export const LOCAL_BUSINESS_SCHEMA = {
  "@type": "LocalBusiness",
  "@id": `${SITE_URL}/#business`,
  name: "DJ Val",
  url: SITE_URL,
  image: `${SITE_URL}/og-dj-val.jpg`,
  logo: ORGANIZATION_LOGO,
  telephone: "+33767908667",
  email: "info.djval@gmail.com",
  priceRange: "€€",
  address: POSTAL_ADDRESS,
} as const;
